<template>
  <div style="display: flex">
    <div class="block">
      <div class="rightSide">
        <div class="text">
          <p>Vous passez</p>
          <p>{{ 100 - slideValue }} % de votre journée</p>
          <p>en intérieur</p>
          <img src="../../../assets/ic-interieur.svg" />
        </div>
        <div
          v-on:click="substractValue"
          class="button"
          v-bind:style="{ width: buttonSize + 'px', height: buttonSize + 'px', borderRadius: buttonSize + 'px' }"
        >
          <img src="../../../assets/triangle-left-arrow.png" />
        </div>
      </div>
      <div class="bodySlider">
        <div class="big">
          <div class="first"></div>
          <div class="second"></div>
          <div class="third"></div>
          <div class="seventh"></div>
        </div>
        <div class="big">
          <input type="range" :min="min" :step="step" :max="max" v-model="slideValue" class="slider" />
          <div class="fourth"></div>
          <div class="fifth"></div>
          <div class="sixth"></div>
          <div class="height"></div>
        </div>
      </div>
      <div class="leftSide">
        <div
          v-on:click="addValue"
          class="button"
          v-bind:style="{ width: buttonSize + 'px', height: buttonSize + 'px', borderRadius: buttonSize + 'px' }"
        >
          <img class="changeSide" src="../../../assets/triangle-left-arrow.png" />
        </div>
        <div class="text">
          <p>Vous passez</p>
          <p>{{ slideValue }} % de votre journée</p>
          <p>en extérieur</p>
          <img src="../../../assets/ic-exterieur.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliderStep',
  props: ['stepNumber'],
  data() {
    return {
      min: 0,
      max: 100,
      step: 25,
      buttonSize: 40,
    };
  },
  computed: {
    slideValue: {
      get: function() {
        return this.$store.getters.getSlideValue(this.stepNumber);
      },
      set: function(value) {
        this.$store.dispatch('changeSlideValue', { step: this.stepNumber, value: value });
      },
    },
  },
  methods: {
    addValue() {
      this.slideValue = Number(this.slideValue);
      if (this.slideValue < this.max) {
        this.slideValue += this.step;
      }
    },
    substractValue() {
      this.slideValue = Number(this.slideValue);
      if (this.slideValue > this.min) {
        this.slideValue -= this.step;
      }
    },
  },
};
</script>

<style scoped>
/* The slider itself */
.slider {
  margin: 0;
  z-index: 1;
  -webkit-appearance: none; /* Override default CSS styles */
  appearance: none;
  cursor: pointer;
  outline: none; /* Remove outline */
  width: 108%;
  transform: translateX(-4%);
  background: no-repeat scroll 0 0 transparent;
}

.slider::-ms-expand {
  display: none;
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 20px; /* Set a specific slider handle width */
  height: 20px; /* Slider handle height */
  cursor: pointer; /* Cursor on hover */
  border-radius: 20px;
  border: 3px solid grey;
  background-repeat: no-repeat;
  background-color: white;
}

.slider::-ms-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 20px; /* Set a specific slider handle width */
  height: 20px; /* Slider handle height */
  cursor: pointer; /* Cursor on hover */
  border-radius: 20px;
  border: 3px solid grey;
  background-repeat: no-repeat;
  background-color: white;
}

::-ms-fill-lower {
  display: none;
}
::-ms-fill-upper {
  display: none;
}

::-ms-track {
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
  width: 100%;
  height: 25px;
}

.block {
  padding: 1em 1em 1em 0;
  background-color: rgba(1, 1, 1, 0);
  display: flex;
  align-items: center;
}

.first {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 50%;
  width: 25%;
  border-right: 1px solid grey;
  border-bottom: 1px solid grey;
}
.second {
  position: absolute;
  bottom: 0;
  left: 25%;
  width: 25%;
  height: 50%;
  border-right: 1px solid grey;
  border-bottom: 1px solid grey;
}
.third {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 25%;
  height: 50%;
  border-right: 1px solid grey;
  border-bottom: 1px solid grey;
}

.fourth {
  position: absolute;
  top: 0;
  left: 0;
  height: 50%;
  width: 25%;
  border-right: 1px solid grey;
}
.fifth {
  position: absolute;
  top: 0;
  left: 25%;
  width: 25%;
  height: 50%;
  border-right: 1px solid grey;
}
.sixth {
  position: absolute;
  top: 0;
  left: 50%;
  width: 25%;
  height: 50%;
  border-right: 1px solid grey;
}
.seventh {
  position: absolute;
  bottom: 0;
  left: 75%;
  width: 25%;
  height: 50%;
  border-bottom: 1px solid grey;
}
.height {
  position: absolute;
  top: 0;
  left: 75%;
  width: 25%;
  height: 50%;
}

.big {
  position: relative;
  border-left: 1px solid grey;
  border-right: 1px solid grey;
  width: 100%;
  height: 50%;
}
.bodySlider {
  width: 20vw;
  height: 8vh;
}
input {
  position: absolute;
  top: -10px;
  /*
        height: 20px;
*/
  left: 0;
}

.rightSide {
  display: flex;
  align-items: center;
  padding-right: 2em;
}
.leftSide {
  display: flex;
  align-items: center;
  padding-left: 2em;
}
.button {
  border: 1px solid grey;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.button:hover {
  border-width: 2px;
}
img {
  width: 10px;
}
.button:hover img {
  width: 12px;
}
.changeSide {
  transform: rotate(180deg);
}

.rightSide .text {
  padding-right: 1vw;
}

.leftSide .text {
  padding-left: 1vw;
}

.text {
  width: 11vw;
}
.text p {
  margin: 0;
  font-size: 1.2vw;
  font-weight: 500;
}

.text img {
  margin-top: 5px;
  width: 40px;
}

/*
for IE 11
*/
@media screen and (min-width: 0\0) {
  input {
    top: -125%;
  }
}
/*
for Edge
*/
@supports (-ms-ime-align: auto) {
  input {
    top: -75%;
  }
}
</style>
